// extracted by mini-css-extract-plugin
module.exports = {"footBtn":"orderSubmit_footBtn__3-zGc","title":"orderSubmit_title__2T92B"};